import { render, staticRenderFns } from "./EventBuybox.vue?vue&type=template&id=308b3558&scoped=true"
import script from "./EventBuybox.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventBuybox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EventBuybox.vue?vue&type=style&index=0&id=308b3558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308b3558",
  null
  
)

export default component.exports